<template>
  <b-card class="border-0">
    <h4><b-icon icon="geo-alt" class="mr-2"/><translate>Contact</translate></h4>
    <ul>
      <li><b>Marius Mihut –</b> <em v-translate> Chief Executive Officer</em><a class="ml-2" href="tel:0034638462377"> 0034/638 462 377</a></li>
      <li><b>Cristina Dascalu –</b> <em v-translate> Administration Department</em><a class="ml-2" href="tel:0034648250409"> 0034/648 250 409</a></li>
      <li><b>Virag Merics –</b> <em v-translate> Head of Reservations Department</em> <a class="ml-2" href="tel:0034638657916"> 0034/638 657 916</a></li>
      <li><b>Emma Stanescu –</b> <em v-translate> Reservations Department</em><a class="ml-2" href="tel:0034638894129">0034/638 894 129</a></li>
    </ul>
  </b-card>
</template>

<script>
export default {
  name: 'emailAddress'
}
</script>

<style lang="scss" scoped>
  .modal-body h4 {
    font-size: 1.3rem;
    color: #293e97;
    border-bottom: 1px solid #ddd;
  }
</style>
